import { createApi } from '@reduxjs/toolkit/dist/query/react'

import {
  Material,
  MaterialStoreRequest,
  MaterialStoreResponse,
  MaterialUpdateRequest,
} from './materialsApi.types'
import { baseQueryWithReauth } from '../../../../redux-store/services/services.utils'
import { ApiSuccessResponse } from '../../../../types'

export const materialsApi = createApi({
  reducerPath: 'materialsApi',
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getMaterialById: builder.query<ApiSuccessResponse<Material>, string>({
      query: (id) => `materials/${id}`,
    }),
    getMaterials: builder.query<
      ApiSuccessResponse<Material[]>,
      { practiceId: string }
    >({
      query: ({ practiceId }) => ({
        method: 'GET',
        url: `practices/${practiceId}/materials`,
      }),
    }),
    storeMaterials: builder.mutation<
      MaterialStoreResponse,
      MaterialStoreRequest
    >({
      query: ({ practice_id, body }) => ({
        method: 'POST',
        url: `practices/${practice_id}`,
        body,
      }),
    }),
    updateMaterial: builder.mutation<null, MaterialUpdateRequest>({
      query: ({ id, body }) => ({
        method: 'PUT',
        url: `materials/${id}`,
        body,
      }),
    }),
    deleteMaterial: builder.mutation<null, { id: string }>({
      query: ({ id }) => ({
        method: 'DELETE',
        url: `materials/${id}`,
      }),
    }),
  }),
})
